<template>
  <div>
    <table-component :dataColumn="dataColumn">
      <template v-slot:header>
        <table-header :title="'ID'" :minWidth="50" :width="200" />
        <table-header :title="$t('user.username')" :minWidth="200" />
        <table-header :title="$t('user.name')" :minWidth="200" />
        <table-header
          :title="$t('common.action')"
          :minWidth="100"
          :width="100"
        />
      </template>
      <template v-slot:body="{ rowData: row, index }">
        <table-cell>{{ index + 1 + (currentPage - 1) * LIMIT }}</table-cell>
        <table-cell>{{ row.userName }}</table-cell>
        <table-cell>{{ row.fullName }}</table-cell>
        <table-cell>
          <i class="el-icon-view icon" @click="handleViewDetail(row.id)" />
          <i class="el-icon-edit icon" @click="handleOpenEditDialog(row)" />
          <i
            class="el-icon-delete icon"
            @click="handleOpenDeleteDialog(row.id)"
          />
        </table-cell>
      </template>
    </table-component>

    <span v-if="userSelected">
      <edit-dialog
        :user="userSelected"
        :openEditDialog="openEditDialog"
        @handleCloseEditDialog="handleCloseEditDialog"
      />
    </span>

    <delete-dialog
      :title="null"
      :content="$t('user.deleteUser')"
      :openDeleteDialog="openDeleteDialog"
      :deleteLoading="deleteUserLoading"
      @handleCloseDialog="handleCloseDeleteDialog"
      @handleConfirm="handleDeleteUser"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { userService } from '@/services/user.service';
import { handleError, notifyMessage, redirectRouter } from '@/helper';
import { LIMIT, PAGE } from '@/constants/common';
import * as pageRouter from '@/constants/pageRouter';

const EditDialog = () => import('../EditUserDialog');
const DeleteDialog = () => import('@/components/Dialog/DialogConfirm.vue');

export default {
  name: 'TableListUser',
  props: {
    dataColumn: Array,
    currentPage: Number,
  },
  components: { EditDialog, DeleteDialog },
  computed: {
    ...mapGetters('user', ['isLoadingUser', 'user']),
  },
  data() {
    return {
      deleteUserLoading: false,
      userSelected: null,
      userIdSelected: null,
      openDeleteDialog: false,
      openEditDialog: false,
      LIMIT,
    };
  },
  methods: {
    ...mapActions('user', ['getUserList']),
    handleOpenDeleteDialog(userId) {
      this.userIdSelected = userId;
      this.openDeleteDialog = true;
    },
    handleCloseDeleteDialog() {
      this.openDeleteDialog = false;
    },
    handleDeleteUser() {
      this.deleteUserLoading = true;

      userService
        .delete(this.userIdSelected)
        .then(() => {
          const userLength = this.user.data.length - 1;

          this.getUserList({
            name: this.$route.query.name,
            page:
              userLength === 0 && +this.$route.query.page > 1
                ? +this.$route.query.page - 1
                : this.$route.query.page || PAGE,
            limit: LIMIT,
          });

          redirectRouter({
            path: pageRouter.USER,
            query: {
              ...this.$route.query,
              page:
                userLength === 0 && +this.$route.query.page > 1
                  ? +this.$route.query.page - 1
                  : this.$route.query.page,
            },
          });
          this.openDeleteDialog = false;
          notifyMessage(this.$t('common.deleteSuccess'), 'success');
        })
        .catch((error) => {
          handleError(error);
        })
        .finally(() => {
          this.deleteUserLoading = false;
        });
    },
    handleOpenEditDialog(user) {
      this.userSelected = user;
      this.openEditDialog = true;
    },
    handleCloseEditDialog() {
      this.openEditDialog = false;
    },
    handleViewDetail(id) {
      redirectRouter({
        path: `/users/${id}`,
      });
    },
  },
};
</script>
